'use client'

import { Spinner } from 'react-bootstrap'

export function LoadingSpinner() {
    return (
        <div className="d-flex justify-content-center mt-3 mb-3">
            <Spinner animation="border" variant="primary" />
        </div>
    )
}
